import {createStructuredSelector} from 'reselect';
import {isFundraisingMode} from '~/selectors/LabModeSelectors';
import {
  getAnchorComplementStyles,
  getAnchorStyle,
  getCurrentSelection,
  getSelectedProductType,
  hasAnchorComplements,
  hasCompatibleStyles,
  isAnchorComplementsLoaded,
  isSelectedProductMask,
  getSelectedProductsIds,
  getSelectedProductColor,
  getAnchorAlternativeStyles
} from '~/selectors/ProductSelectors';
import {hasSleeveDesign} from '~/selectors/CanvasSelectors';
import {isMultiItemEligible} from '~/selectors/ConfigSelectors';
import {getIconsArray} from '~/selectors/CanvasSelectors';
import {getProductViews} from '~/selectors/ProductSelectors';

export const select = () => {
  return createStructuredSelector({
    alternatives: getAnchorAlternativeStyles,
    anchorStyle: getAnchorStyle,
    complements: getAnchorComplementStyles,
    complementsLoaded: isAnchorComplementsLoaded,
    icons: getIconsArray,
    isFundraisingMode,
    isMultiItemEligible,
    isSelectedProductMask,
    hasComplements: hasAnchorComplements,
    hasCompatibleStyles,
    getProductViews,
    selectedProduct: getCurrentSelection,
    selectedProducts: getSelectedProductsIds,
    selectedProductColor: getSelectedProductColor,
    selectedProductType: getSelectedProductType,
    hasSleeveDesign
  });
};

import {bindActionCreators as bind} from 'redux';
import {loadStyles} from '~/actions/CatalogActions';
import * as analyticsActions from '~/actions/AnalyticsActions';
import {loadAnchorComplements} from '~/actions/ComplementsActions';
import {loadAnchorCompatibleStyles} from '~/actions/CompatibleStylesActions';

export const actions = dispatch => {
  return {
    ...bind(
      {
        loadStyles,
        loadAnchorComplements,
        loadAnchorCompatibleStyles
      },
      dispatch
    ),
    meta: bind(analyticsActions, dispatch)
  };
};
